









import { Vue, Component, Prop } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { Button, Dialog, Toast, Popup } from 'vant';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {},
})
export default class ShowList extends Vue {
  @Prop() public item!: any;
  @Prop() public type!: any;
  public UnOpened = false;
  public Opening = false;
  created() {
    if (this.type === 1 || this.type === '1') {
      if (
        this.item.start_time * 1000 === 0 ||
        new Date().getTime() < this.item.start_time * 1000
      ) {
        this.UnOpened = true;
      } else if (this.item.end_time * 1000 > new Date().getTime()) {
        this.Opening = true;
      }
    } else {
      if (
        this.item.createtime * 1000 === 0 ||
        new Date().getTime() < this.item.createtime * 1000
      ) {
        this.UnOpened = true;
      } else {
        this.Opening = true;
      }
    }
  }
  enterDetailPage(type: any) {
    if (!this.UnOpened) {
      if (type === 1 || type === '1') {
        if (this.Opening) {
          this.$router.push({
            name: 'SSHDLiveRoom',
            params: { roomNumber: this.item.id },
          });
        } else {
          this.$router.push({
            path: '/20200710SSHD/LivePage',
            query: { id: this.item.id },
          });
        }
      } else if (type === 2 || type === '2') {
        if (this.Opening) {
          this.$router.push({
            path: '/20200710SSHD/VideoPage',
            query: { id: this.item.id },
          });
        }
      } else if (type === 3 || type === '3') {
        if (this.Opening) {
          this.$router.push({
            path: '/20200710SSHD/TextPage',
            query: { id: this.item.id },
          });
        }
      }
    }
  }
}
